/** Link helpers for the pp2 page (spec 5.5, 5.7, 3.5). */

export type Pp2Link = { label: string; href: string };

// eslint-disable-next-line require-unicode-regexp -- ASCII-only regex (the v flag is not supported by our browser targets)
const LEADING_PROTOCOL = /^https?:\/\//i;

/** True for an absolute http(s) URL. */
export const isHttpUrl = (value: string): boolean => LEADING_PROTOCOL.test(value);

/** "Set" in the spec: a non-empty string after trim(). Returns the trimmed value or null. */
export const trimmedOrNull = (value: Nullable<string> | undefined): string | null => value?.trim() || null;

/** `tel:` + the number with everything except digits and a leading `+` removed. */
export function phoneLink(value: string): Pp2Link {
  const label = value.trim();
  const plus = label.startsWith("+") ? "+" : "";
  // eslint-disable-next-line require-unicode-regexp -- ASCII-only regex
  return { label, href: `tel:${plus}${label.replace(/\D/g, "")}` };
}

export function emailLink(value: string): Pp2Link {
  const label = value.trim();
  return { label, href: `mailto:${label}` };
}

/** href gets `https://` when it has no http(s) scheme; the label drops the scheme and one trailing `/`. */
export function websiteLink(value: string): Pp2Link {
  const trimmed = value.trim();
  const href = isHttpUrl(trimmed) ? trimmed : `https://${trimmed}`;
  const withoutProtocol = trimmed.replace(LEADING_PROTOCOL, "");
  const label = withoutProtocol.endsWith("/") ? withoutProtocol.slice(0, -1) : withoutProtocol;
  return { label, href };
}

/** Google Maps URLs API search link ("Open in Maps"). */
export function mapsUrl(address: string | null, displayName: string, placeId: string | null): string {
  const query = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address || displayName)}`;
  return placeId ? `${query}&query_place_id=${encodeURIComponent(placeId)}` : query;
}

export const BANNER_UTM_CAMPAIGN = "payment_page_v2_banner";

/** "Get the free app" link of the ANNA banner (owner decision Q19). */
export const bannerUrl = (publicId: string | null): string =>
  `https://go.anna.money/accept-payments/?utm_source=${encodeURIComponent(publicId ?? "")}&utm_campaign=${BANNER_UTM_CAMPAIGN}`;

export const APP_STORE_URL = "https://apps.apple.com/app/id1333008275";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.anna.money.app";
